import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { FormDialog, Loading, Pill, Table, Title, useData } from "@/ops/ui";

export function projectFields(clients) {
  return [
    { k: "name", label: "Proje / Hizmet noktası adı", required: true, wide: true },
    { k: "client_id", label: "Müşteri", type: "select", options: [["", "Müşteri seçilmedi"], ...(clients || []).map((c) => [c.id, c.name])], wide: true },
    { k: "address", label: "Adres", type: "textarea" },
    { k: "lat", label: "Enlem (isteğe bağlı)", type: "number", step: "any", hint: "Gerekmez: kontrol noktalarının konumunu sahada telefonla kaydedebilirsiniz." },
    { k: "lng", label: "Boylam (referans konum)", type: "number", step: "any" },
    { k: "radius_m", label: "Özel kabul mesafesi (metre)", type: "number", hint: "Boş bırakılırsa GPS Ayarları'ndaki varsayılan (100 m) kullanılır." },
    { k: "location_interval_min", label: "Vardiya boyunca konum aralığı (dakika)", type: "number", hint: "0 = kapalı. Açıksa personel ekranı açıkken bu aralıkla konum kaydedilir." },
    { k: "photo_required", label: "Devriye okutmasında fotoğraf zorunlu", type: "bool", wide: true },
    { k: "share_patrols", label: "Devriye raporlarını müşteriyle paylaş", type: "bool", wide: true },
    { k: "active", label: "Aktif proje", type: "bool", wide: true },
    { k: "notes", label: "Notlar", type: "textarea" },
  ];
}

const PROJECT_HEAD = ["Kod", "Proje", "Müşteri", "Nokta", "Personel", "Yarıçap", "Durum", ""];

export default function Projects() {
  const [rows, reload] = useData("/ops/admin/projects");
  const [clients] = useData("/ops/admin/clients");
  const [form, setForm] = useState(null);
  const save = (v) => api.post("/ops/admin/projects", v).then(() => toast.success("Proje oluşturuldu"));
  return (
    <div>
      <Title title="Projeler ve Kontrol Noktaları" desc="Her proje için kontrol noktaları, QR kodlar, devriye güzergâhları ve personel ataması.">
        <button onClick={() => setForm({ active: true, location_interval_min: 0 })} className="btn-red !py-2" data-testid="project-add-btn"><Plus className="h-4 w-4" /> Proje Ekle</button>
      </Title>
      {!rows ? <Loading /> : (
        <Table head={PROJECT_HEAD} testid="projects-table">
          {rows.map((p) => (
            <tr key={p.id} data-testid={`project-row-${p.id}`}>
              <td className="px-3 py-2 font-semibold text-[color:var(--red)]">{p.code}</td><td className="px-3 py-2 font-semibold">{p.name}</td>
              <td className="px-3 py-2">{p.client_name || "-"}</td><td className="px-3 py-2">{p.checkpoints}</td><td className="px-3 py-2">{p.staff}</td><td className="px-3 py-2">{p.radius_m ? `${p.radius_m} m` : "Varsayılan"}</td>
              <td className="px-3 py-2"><Pill ok={p.active}>{p.active ? "Aktif" : "Pasif"}</Pill></td>
              <td className="px-3 py-2"><Link to={`/operasyon/projeler/${p.id}`} className="inline-flex items-center text-sm font-semibold text-[color:var(--red)]" data-testid={`project-open-${p.id}`}>Yönet <ChevronRight className="h-4 w-4" /></Link></td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={8} className="p-6 text-center text-zinc-500">Henüz proje yok.</td></tr>}
        </Table>
      )}
      <FormDialog open={!!form} title="Yeni Proje" fields={projectFields(clients)} initial={form} onSubmit={save} onClose={(ok) => { setForm(null); if (ok) reload(); }} />
    </div>
  );
}
